/**
 * Get translated name from an item with translations.
 * Falls back to item.name if no translation for the current language.
 */
export function getTranslatedName(item, lang) {
  if (lang !== 'en' && item?.translations?.[lang]) return item.translations[lang];
  return item?.name || '';
}

/**
 * Create a lookup map: { englishName: translatedName }
 * Useful for translating breed/category strings stored in ads.
 */
export function createTranslationMap(items, lang) {
  const map = {};
  for (const item of items) {
    map[item.name] = getTranslatedName(item, lang);
  }
  return map;
}
